module.exports = __webpack_public_path__ + "static/media/1012994.e3f79aae.jpg";